import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	standardLozenge: {
		id: 'paid-feature-awareness.standard-lozenge',
		defaultMessage: 'Standard',
		description: 'Text displayed in the standard plan lozenge',
	},
	premiumLozenge: {
		id: 'paid-feature-awareness.premium-lozenge',
		defaultMessage: 'Premium',
		description: 'Text displayed in the premium plan lozenge',
	},
	standardTooltip: {
		id: 'paid-feature-awareness.standard-tooltip',
		defaultMessage: 'This is a Standard plan feature',
		description: 'Tooltip text for standard plan features',
	},
	premiumTooltip: {
		id: 'paid-feature-awareness.premium-tooltip',
		defaultMessage: 'This is a Premium plan feature',
		description: 'Tooltip text for premium plan features',
	},
	automationTooltip: {
		id: 'paid-feature-awareness.automation-tooltip',
		defaultMessage:
			'Automations varies by plan. Free: 100 rule runs/mo; Standard: 1,700 rule runs/mo; Premium: 1000 rule runs per user/mo',
		description: 'Tooltip text for automation features',
	},
});
